/**
 * FloatingActionButtons - FAB for edit mode save/discard
 */
import React from 'react';
import { Check, X } from 'lucide-react';

interface FloatingActionButtonsProps {
  onSaveAll: () => void;
  onDiscardChanges: () => void;
}

export const FloatingActionButtons: React.FC<FloatingActionButtonsProps> = ({
  onSaveAll,
  onDiscardChanges
}) => {
  return (
    <div className="fixed bottom-8 right-8 flex flex-col gap-3 z-40">
      <button
        onClick={onSaveAll}
        className="group flex items-center gap-3 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-green-500/50 transition-all duration-300 transform hover:scale-105"
        title="Salvar todas as alterações"
      >
        <Check size={24} className="flex-shrink-0" />
        <span className="font-bold text-base whitespace-nowrap">Salvar Tudo</span>
      </button>

      <button
        onClick={onDiscardChanges}
        className="group flex items-center gap-3 bg-gradient-to-r from-red-500 to-rose-600 hover:from-red-600 hover:to-rose-700 text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-red-500/50 transition-all duration-300 transform hover:scale-105"
        title="Descartar todas as alterações"
      >
        <X size={24} className="flex-shrink-0" />
        <span className="font-bold text-base whitespace-nowrap">Descartar</span>
      </button>
    </div>
  );
};
